import React from 'react';
import { CardGroup } from 'shared-components';
import AppStatus from './AppStatus';
import PastIncidents from './PastIncidents';
import useTellerApi from '../../hooks/useTellerApi';

function SystemIncidents() {
  const [
    {
      data: { data: pastIncidents },
      isLoading,
      isError,
    },
  ] = useTellerApi('/api/v1/client_portal/incidents?latest_first=true', {});
  return (
    <CardGroup>
      <AppStatus pastIncidents={pastIncidents || []} />
      <PastIncidents
        pastIncidents={pastIncidents || []}
        isLoading={isLoading}
        isError={isError}
      />
    </CardGroup>
  );
}

export default SystemIncidents;
